<template lang="jade">
  div
    link(rel="stylesheet" href="./static/css/style.css")
    link(rel="stylesheet" href="./static/css/button3d.css")
    link(rel="stylesheet" href="./static/css/sweetalert.min.css")
    link(href="https://fonts.googleapis.com/css?family=Rubik" rel="stylesheet")
    main-header(v-if="$store.state.authorization")
    router-view
</template>

<script>
import MainHeader from './components/MainHeader.vue'

export default {
  name: 'app',
  components: {
    MainHeader
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?8174acf8